import type { StaticApplicationsWebMessengerWebMessengerConfigurationDto } from '@ori/static-api-client-react';

export const prepareGenesysScript = ({
  deploymentId,
  environment,
  scriptUrl,
}: StaticApplicationsWebMessengerWebMessengerConfigurationDto | undefined = {}) => {
  if (!window.Genesys) {
    Object.defineProperty(window, 'Genesys', { writable: true, value: {} });
  }
  if (deploymentId && environment && scriptUrl) {
    window._genesysJs = 'Genesys';
    Object.defineProperty(window, 'Genesys', {
      writable: true,
      value: {
        t: Date.now(),
        c: {
          environment,
          deploymentId,
          debug: process.env.NODE_ENV !== 'production',
        },
      },
    });
    const script = document.createElement('script');
    script.src = scriptUrl;

    return script;
  }

  return null;
};
